import { gql } from '@apollo/client'

export default gql(`
    mutation updatePublishingGroup($id: ID! $name: String! $project: String ) {
        updatePublishingGroup(
            input: {
                id: $id
                name: $name
            }
            project: $project
        ) {
            id
            name 
            status
            isDefault
            isEnvironment
            countries
        }
    }`
)
